import React, { useContext } from 'react';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import classNames from 'classnames';

import { Typography } from '@comparethemarketau/manor-typography';

const useStyles = createUseStyles((theme) => ({
    text: {
        fontSize: theme.fontSize.sm,
        fontWeight: theme.fontWeight.normal,
        lineHeight: theme.lineHeight.normal
    },
    strong: {
        fontSize: theme.fontSize.sm,
        fontWeight: theme.fontWeight.semibold,
        lineHeight: theme.lineHeight.normal
    }
}));

const PriceDisclaimer = () => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <div className="test-policyProduct-priceDisclaimer">
            <Typography component="span" className={classNames(classes.text)}>
                {'Quotes are indicative and subject to change based on further questions asked by the insurer. '}
                <Typography component="span" className={classNames(classes.strong)}>
                    {'The information on this page is subject to exclusions, restrictions and sub-limits. Please refer to the PDS for details.'}
                </Typography>
            </Typography>
        </div>
    );
};

export { PriceDisclaimer };
